import { Button, Form } from 'antd';
import React, { useEffect, useState } from 'react';

import { ButtonGroup, Drawer, ErrorHandler } from '@common/components';
import { useQuery } from '@common/hooks';
import { ComplianceItemAddAttachmentForm } from '@onboarding/components';
import {
  ComplianceItemUpsertDrawerQuery,
  ComplianceItemUpsertDrawerQueryType,
} from '@onboarding/graphql';

const refetchQueries = [
  'PaginatedWorksListItems',
  'CandidateAssignmentQueryComplianceTabQuery',
  'ComplianceItemDrawerQuery',
  'ComplianceItemUpsertDrawerV2Query',
  'ComplianceItemDrawerFilesTabQuery',
];

export function ComplianceItemAddAttachmentDrawer({
  open,
  onClose,
  complianceItemId = '',
}: {
  open: boolean;
  onClose: () => void;
  complianceItemId?: string;
}) {
  const [form] = Form.useForm();
  const [formLoading, setFormLoading] = useState(false);

  const { data, loading, error, refetch } =
    useQuery<ComplianceItemUpsertDrawerQueryType>(
      ComplianceItemUpsertDrawerQuery,
      {
        skip: !complianceItemId,
        variables: { id: complianceItemId },
        fetchPolicy: 'no-cache',
      }
    );

  useEffect(() => {
    form.resetFields();
  }, [form, data?.worksListItem.detailItem]);

  if (error) {
    return (
      <ErrorHandler
        error={error}
        messageType="contextual"
        log="ComplianceItemAddAttachmentDrawer"
      />
    );
  }

  const complianceItem = data?.worksListItem;

  function onCloseDrawer() {
    form.resetFields();
    onClose();
  }

  return (
    <Drawer
      className="compliance-item-add-attachment-drawer"
      open={open}
      onClose={onCloseDrawer}
      title={data ? `Add ${data.worksListItem?.typeName}` : undefined}
      loading={loading}
      footer={
        <ButtonGroup>
          <Button size="large" onClick={onCloseDrawer}>
            Back
          </Button>
          <Button
            type="primary"
            size="large"
            loading={formLoading}
            onClick={form.submit}
          >
            Save
          </Button>
        </ButtonGroup>
      }
    >
      {complianceItem && (
        <ComplianceItemAddAttachmentForm
          form={form}
          refetchQueries={refetchQueries}
          complianceItem={complianceItem}
          onSubmit={() => setFormLoading(true)}
          onSuccess={() => {
            refetch();
            onCloseDrawer();
            setFormLoading(false);
          }}
          onError={() => setFormLoading(false)}
        />
      )}
    </Drawer>
  );
}
